import { IJobWorkBillV2 } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	subPartyId: string
	productId: string
	issueDate: string
	fullBillNo: string
	workRate: number
	quantity: number
	note: string | null
}

interface ResponseDataShape {
	success: boolean
	data: IJobWorkBillV2
}

export async function inwardJobWorkBillAddApi(payload: RequestDataShape, token: string) {
	const endpoint = "/inwardJobWorkBill/add/v2"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response.data
}
